// @ts-nocheck
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import {BotonVerde} from "../Difusiones/Componentes/BotonVerde";

const useStyles = makeStyles( theme => ({
    root:{
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

function FormButton(props) {
    const {text, ...other} = props;
    const classes = useStyles();
    return (
        <BotonVerde
            variant="contained"
            disableElevation
            {...other}
        >
            {text}
        </BotonVerde>
    );
}

export default FormButton;
